import useBool from '../../utils/state/useBool';
import { VideoDialog } from './VideoDialog/VideoDialog';

interface Props {
  title?: string;
  source?: { drive_id: string };
  children(props: { showDialog: () => void }): JSX.Element;
}

export const VideoDialogAnchor = (props: Props) => {
  const [visible, showDialog, hideDialog] = useBool();

  return props.source ? (
    <>
      {props.children({ showDialog })}

      <VideoDialog
        title={props.title}
        visible={visible}
        onClose={hideDialog}
        source={props.source}
      />
    </>
  ) : null;
};
